import React, { useState, useEffect } from 'react';
import { 
  GraduationCap, 
  Layers, 
  BookOpen, 
  Library, 
  Lightbulb, 
  ClipboardCheck, 
  Sparkles 
} from 'lucide-react';
import EducationProgramHeroForm from './EducationProgramHeroForm';
import EducationProgramLevelsForm from './EducationProgramLevelsForm';
import EducationCurriculumOverviewForm from './EducationCurriculumOverviewForm';
import EducationSubjectsOfferedForm from './EducationSubjectsOfferedForm';
import EducationLearningApproachForm from './EducationLearningApproachForm';
import EducationAssessmentSystemForm from './EducationAssessmentSystemForm';
import EducationSpecialProgramsForm from './EducationSpecialProgramsForm';
import SecondaryPageForm from './SecondaryPageForm';
import './FormsUnified.css';

export default function EducationForm({ apiBase, activeTab }) {
  const [currentSection, setCurrentSection] = useState('hero');

  useEffect(() => {
    if (activeTab === 'cms-education-hero' || activeTab === 'cms-edu-hero' || activeTab === 'hero') {
      setCurrentSection('hero');
    } else if (activeTab === 'cms-edu-programs' || activeTab === 'programs' || activeTab === 'levels' || activeTab === 'academic-pathways' || activeTab === 'pathways') {
      setCurrentSection('programs');
    } else if (activeTab === 'cms-edu-curriculum' || activeTab === 'curriculum') {
      setCurrentSection('curriculum');
    } else if (activeTab === 'cms-edu-subjects' || activeTab === 'subjects') {
      setCurrentSection('subjects');
    } else if (activeTab === 'cms-edu-learning' || activeTab === 'learning') {
      setCurrentSection('learning');
    } else if (activeTab === 'cms-edu-assessment' || activeTab === 'assessment') {
      setCurrentSection('assessment');
    } else if (activeTab === 'cms-edu-special-programs' || activeTab === 'special-programs' || activeTab === 'special') {
      setCurrentSection('special-programs');
    } else if (activeTab === 'cms-edu-secondary' || activeTab === 'secondary' || activeTab === 'secondary-page') {
      setCurrentSection('secondary');
    }
  }, [activeTab]);

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'hero' ? 'active' : ''}`}
          onClick={() => setCurrentSection('hero')}
        >
          <GraduationCap className="w-4 h-4 mr-2" />
          <span>Hero Banner</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'programs' ? 'active' : ''}`}
          onClick={() => setCurrentSection('programs')}
        >
          <Layers className="w-4 h-4 mr-2" />
          <span>Academic Pathways</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'curriculum' ? 'active' : ''}`}
          onClick={() => setCurrentSection('curriculum')}
        >
          <BookOpen className="w-4 h-4 mr-2" />
          <span>Curriculum Overview</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'subjects' ? 'active' : ''}`}
          onClick={() => setCurrentSection('subjects')}
        >
          <Library className="w-4 h-4 mr-2" />
          <span>Subjects Offered</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'learning' ? 'active' : ''}`}
          onClick={() => setCurrentSection('learning')}
        >
          <Lightbulb className="w-4 h-4 mr-2" />
          <span>Learning Approach</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'assessment' ? 'active' : ''}`}
          onClick={() => setCurrentSection('assessment')}
        >
          <ClipboardCheck className="w-4 h-4 mr-2" />
          <span>Assessment System</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'special-programs' ? 'active' : ''}`}
          onClick={() => setCurrentSection('special-programs')}
        >
          <Sparkles className="w-4 h-4 mr-2" />
          <span>Special Programs</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'secondary' ? 'active' : ''}`}
          onClick={() => setCurrentSection('secondary')}
        >
          <GraduationCap className="w-4 h-4 mr-2" />
          <span>Secondary Detail Page</span>
        </button>
      </div>

      {/* Render Active Section Form */}
      <div className="unified-tab-content">
        {currentSection === 'hero' && <EducationProgramHeroForm apiBase={apiBase} />}
        {currentSection === 'programs' && <EducationProgramLevelsForm apiBase={apiBase} />}
        {currentSection === 'curriculum' && <EducationCurriculumOverviewForm apiBase={apiBase} />}
        {currentSection === 'subjects' && <EducationSubjectsOfferedForm apiBase={apiBase} />}
        {currentSection === 'learning' && <EducationLearningApproachForm apiBase={apiBase} />}
        {currentSection === 'assessment' && <EducationAssessmentSystemForm apiBase={apiBase} />}
        {currentSection === 'special-programs' && <EducationSpecialProgramsForm apiBase={apiBase} />}
        {currentSection === 'secondary' && <SecondaryPageForm apiBase={apiBase} />}
      </div>
    </div>
  );
}
